<template lang="html">
  <action-bar>
    <!-- Left -->
    <template slot="left">
      <!-- Back -->
      <div class="dn db-l" v-if="!favouritesMode">
        <advanced-select :label="typeLabel"
          @apply="applyTypeFilters"
          @cancel="revertMutableFilters"
          @reset="resetTypeFilters"
          :requiresApply="true"
        >
          <check-list v-model="mutableFilters.typeList"
            :responsive="true"
            class="mb3"
          />
        </advanced-select>
        <advanced-select :label="viewsLabel"
          @apply="applyViewFilters"
          @cancel="revertMutableFilters"
          @reset="resetViewFilters"
          :requiresApply="true"
        >
          <check-list v-model="mutableFilters.viewList"
            :responsive="true"
            class="mb3"
          />
        </advanced-select>
        <advanced-select label="More Filters"
          @apply="applyMoreFilters"
          @cancel="revertMutableFilters"
          @reset="resetMoreFilters"
          :requiresApply="true"
          :fillWidth="true"
        >
          <check-list v-model="mutableFilters.bathList"
            title="Bathrooms"
            :responsive="true"
            class="mb4"
          />
          <range-slider title="Size"
            :range="{
              min: mutableFilters.sqftRange.min,
              max: mutableFilters.sqftRange.max
            }"
            :defaultRange="mutableFilters.sqftRange.default"
            unitLabel="sqft"
            @change="updateSqftRange"
            class="mb4"
          />
          <range-slider title="Floors"
            :range="{
              min: mutableFilters.floorRange.min,
              max: mutableFilters.floorRange.max
            }"
            :defaultRange="mutableFilters.floorRange.default"
            @change="updateFloorRange"
            class="mb4"
          />
        </advanced-select>
      </div>
      <div class="dn-l" v-if="!favouritesMode">
        <advanced-select label="Filters"
          @apply="applyAllFilters"
          @cancel="revertMutableFilters"
          @reset="resetAllFilters"
          :requiresApply="true"
          :fillWidth="true"
        >
          <check-list v-model="mutableFilters.typeList"
            title="Type"
            :responsive="true"
            class="mb5 mb4-ns"
          />
          <check-list v-model="mutableFilters.viewList"
            title="View"
            :responsive="true"
            class="mb5 mb4-ns"
          />
          <check-list v-model="mutableFilters.bathList"
            title="Bathrooms"
            :responsive="true"
            class="mb5 mb4-ns"
          />
          <range-slider title="Size"
            :range="{
              min: mutableFilters.sqftRange.min,
              max: mutableFilters.sqftRange.max
            }"
            :defaultRange="mutableFilters.sqftRange.default"
            unitLabel="sqft"
            @change="updateSqftRange"
            class="mb4"
          />
          <range-slider title="Floors"
            :range="{
              min: mutableFilters.floorRange.min,
              max: mutableFilters.floorRange.max
            }"
            :defaultRange="mutableFilters.floorRange.default"
            @change="updateFloorRange"
            class="mb4"
          />
        </advanced-select>
      </div>
      <div v-if="favouritesMode">
        <v-btn
          label="Download Favourites"
          icon-code="picture_as_pdf"
          icon-pos="left"
          class="bg-transparent hover-action f6 b dib"
          @click.native="downloadFavourites()"
          v-if="!isTouchscreen"
        />
        <a ref="downloadLink" :href="downloadLink" download v-if="downloadLink"></a>
        <v-btn
          label="Email floorplans"
          icon-code="email"
          icon-pos="left"
          class="bg-transparent hover-action f6 b dib"
          @click.native="emailFloorplans()"
          v-if="isTouchscreen"
        />
        <v-btn
          label="Get favourites link"
          icon-code="link"
          icon-pos="left"
          class="bg-transparent hover-action f6 b dib"
          v-if="false"
        />
      </div>
    </template>

    <!-- Right -->
    <template slot="right">
      <div class="db" v-if="!getListView">
        <single-select
          label="Sort"
          @change="handleSqftSort"
          :options="[
            'Sqft Ascending',
            'Sqft Descending'
          ]"
          :selectedIndex="sortIndex"
        />
      </div>
      <div class="db ph2 mh2 pointer user-select-none" @click="TOGGLE_LIST_VIEW()">
        <i class="material-icons br b--black pr1"
          :class="{'moon-gray': getListView, 'hover-action': getListView }"
        >&#xE8F0;</i>
        <i class="material-icons pl"
          :class="{'moon-gray': !getListView, 'hover-action': !getListView }"
        >&#xE8FE;</i>
      </div>
      <div>
        <v-btn v-if="!favouritesMode"
          @click.native="TOGGLE_VIEWING_FAVOURITES()"
          :label="favouritesCount"
          icon-code="star"
          icon-pos="left"
          icon-class="f4"
          class="interact-bg-favourite b raise font-futura-bold"
        />
        <v-btn v-else
          @click.native="TOGGLE_VIEWING_FAVOURITES()"
          icon-code="close"
          icon-pos="left"
          class="b bg-transparent"
        />
      </div>
    </template>
  </action-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ButtonComponent from '@/components/Button';
import SingleSelectComponent from '@/components/SingleSelect';
import CheckListComponent from '@/components/CheckList';
import RangeSliderComponent from '@/components/RangeSlider';
import AdvanceSelectComponent from '@/components/AdvanceSelect';
import ActionBar from '@/components/ActionBar';

export default {
  components: {
    'v-btn': ButtonComponent,
    'single-select': SingleSelectComponent,
    'check-list': CheckListComponent,
    'range-slider': RangeSliderComponent,
    'advanced-select': AdvanceSelectComponent,
    'action-bar': ActionBar
  },
  computed: {
    ...mapGetters({
      isTouchscreen: 'isTouchscreen',
      filters: 'getFilters',
      getListView: 'listMode',
      favourites: 'favourites',
      viewingFavoritesList: 'viewingFavoritesList',
      favouritesMode: 'favouritesMode'
    }),
    typeLabel() {
      return this.getLabelByType('typeList', 'Type');
    },
    viewsLabel() {
      return this.getLabelByType('viewList', 'Views');
    },
    favouritesCount() {
      const favouritesCount = this.favourites.length;
      return favouritesCount.toString();
    }
  },
  data() {
    return {
      downloadLink: false,
      mutableFilters: {},
      sortIndex: 0
    };
  },
  created() {
    this.revertMutableFilters();
  },
  watch: {
    filters() {
      this.revertMutableFilters();
    }
  },
  methods: {
    ...mapActions([
      'SET_EMAIL_LIST',
      'DOWNLOAD_FAVOURITES',
      'UPDATE_FILTERS_TYPES',
      'UPDATE_FILTERS_VIEWS',
      'UPDATE_FILTERS_BATHS',
      'SET_FLOOR_RANGE',
      'SET_SQFT_RANGE',
      'SORT_SQFT_ASC',
      'SORT_SQFT_DESC',
      'TOGGLE_EMAIL_FLOORPLANS',
      'TOGGLE_LIST_VIEW',
      'TOGGLE_VIEWING_FAVOURITES'
    ]),
    downloadFavourites() {
      this.DOWNLOAD_FAVOURITES()
        .then((res) => {
          if (res.statusCode === 200) {
            this.downloadLink = res.downloadUrl;
            setTimeout(() => {
              this.$refs.downloadLink.click();
            }, 100, this);
          }
        });
    },
    emailFloorplans() {
      this.SET_EMAIL_LIST(this.favourites);
      this.TOGGLE_EMAIL_FLOORPLANS(true);
    },
    getLabelByType(filterType, filterLabel) {
      const activeFilters = this.getActiveFiltersByType(filterType);
      const activeCount = activeFilters.length;
      if (activeCount === 1) return activeFilters[0].label;
      else if (activeCount > 1) return `${filterLabel} (${activeCount})`;
      return filterLabel;
    },
    getActiveFiltersByType(filterType) {
      return this.mutableFilters[filterType].filter(filter => filter.active);
    },
    applyTypeFilters() {
      this.UPDATE_FILTERS_TYPES(this.mutableFilters.typeList);
    },
    resetTypeFilters() {
      this.mutableFilters.typeList.forEach((type) => { type.active = false; });
    },
    applyViewFilters() {
      this.UPDATE_FILTERS_VIEWS(this.mutableFilters.viewList);
    },
    resetViewFilters() {
      this.mutableFilters.viewList.forEach((view) => { view.active = false; });
    },
    applyMoreFilters() {
      this.SET_SQFT_RANGE(this.mutableFilters.sqftRange);
      this.SET_FLOOR_RANGE(this.mutableFilters.floorRange);
      this.UPDATE_FILTERS_BATHS(this.mutableFilters.bathList);
    },
    handleSqftSort(index) {
      switch (index) {
        case 0: // Sort asc
          this.SORT_SQFT_ASC();
          break;
        default: // Sort desc
          this.SORT_SQFT_DESC();
      }
      this.sortIndex = index;
    },
    revertMutableFilters() {
      this.mutableFilters = JSON.parse(JSON.stringify(this.filters));
    },
    resetMoreFilters() {
      this.mutableFilters.bathList.forEach((bath) => { bath.active = false; });
      this.mutableFilters.sqftRange.min = this.mutableFilters.sqftRange.default.min;
      this.mutableFilters.sqftRange.max = this.mutableFilters.sqftRange.default.max;
      this.mutableFilters.floorRange.min = this.mutableFilters.floorRange.default.min;
      this.mutableFilters.floorRange.max = this.mutableFilters.floorRange.default.max;
    },
    updateSqftRange(newSqftRange) {
      this.mutableFilters.sqftRange.min = newSqftRange.min;
      this.mutableFilters.sqftRange.max = newSqftRange.max;
    },
    updateFloorRange(newFloorRange) {
      this.mutableFilters.floorRange.min = newFloorRange.min;
      this.mutableFilters.floorRange.max = newFloorRange.max;
    },
    applyAllFilters() {
      this.applyTypeFilters();
      this.applyViewFilters();
      this.applyMoreFilters();
    },
    resetAllFilters() {
      this.resetTypeFilters();
      this.resetViewFilters();
      this.resetMoreFilters();
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanList/FloorplanListActions.vue